import AppointmentView from './AppointmentView';
export default AppointmentView;